import { render, staticRenderFns } from "./KakaoGroup.vue?vue&type=template&id=12ff443e&scoped=true"
import script from "./KakaoGroup.vue?vue&type=script&lang=js"
export * from "./KakaoGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff443e",
  null
  
)

export default component.exports